/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchReferralResponse } from './search-referral-response';


export interface SearchReferralResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchReferralResponse> | null;
}

